import { useMutation } from '@apollo/client';
import { UpdateProjectContractTermDocument } from './mutation.gql';
export const useUpdateProjectContractTerm = () => {
    const [mutate, state] = useMutation(UpdateProjectContractTermDocument);
    const updateProjectContractTerm = (id, contractTerm) => mutate({
        variables: { id, contractTerm },
        optimisticResponse: {
            updateFileSystemProject: {
                __typename: 'FileSystemProject',
                id,
                contractTerm,
            },
        },
        update(cache, { data }) {
            const { updateFileSystemProject } = data || {};
            if (updateFileSystemProject) {
                const { contractTerm: newContractTerm } = updateFileSystemProject;
                cache.modify({
                    id: cache.identify({ id, __typename: 'FileSystemProject' }),
                    fields: {
                        contractTerm() {
                            return newContractTerm;
                        },
                        updatedAt() {
                            return new Date().toISOString();
                        },
                    },
                });
            }
        },
    });
    return [updateProjectContractTerm, state];
};
